<template>
  <DistributionPlan is-verify />
</template>
<script>
import DistributionPlan from '@/views/center-business/stock/distribution/plan/index';
export default {
  name: 'BusinessStockVerifyPlanIndex',
  components: {
    DistributionPlan,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
